import HttpRequest from './core/http_request';

class MasterProvider extends HttpRequest {
  getProvinceStructure () {
    return this.request('get', '/public/getProvinceStructure');
  }
}

export default MasterProvider;
